import { render, staticRenderFns } from "./home-box4.vue?vue&type=template&id=622d56a0&scoped=true&"
import script from "./home-box4.vue?vue&type=script&lang=js&"
export * from "./home-box4.vue?vue&type=script&lang=js&"
import style0 from "./home-box4.vue?vue&type=style&index=0&id=622d56a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d56a0",
  null
  
)

export default component.exports